// Es un bug de Eslint que se doluciona en versiones mas actualizadas
/* eslint-disable no-shadow */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Form, Row, Col, Button, Accordion, Card, Spinner } from 'react-bootstrap';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import { map, isEmpty, debounce, isNil } from 'lodash';
import turf from '@turf/turf';
import { Bert } from 'meteor/themeteorchef:bert';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';
import ModalElement from '../../components/ModalElement';
import PaginationComponent from '../../components/PaginationInterval';
import MapContainerCatalogos from '../../containers/MapContainerCatalogos';
import methodPromise from '../../../modules/method-promise-wrapper';
import { useStyles } from '../../../styles/mapStylesCustom';

const NewDBExternal = props => {
  const [indexJson, setIndexJson] = React.useState({});
  const [indexArray, setIndexArray] = React.useState(0);
  const [exist, SetExist] = React.useState(false);
  const [loading, SetLoading] = React.useState(false);
  const [loadingCAT, SetLoadingCAT] = React.useState(false);
  const [error, SetError] = React.useState(false);
  const [fetaureid, setFeatureId] = React.useState('');
  const [filte, setFilte] = React.useState([]);
  const [subType, setSubType] = React.useState('');
  const [search, setSearch] = React.useState('');
  const [elementePage, setElementPage] = React.useState(15);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [modalShow, setModalShow] = React.useState(false);
  const [aiInterestArea, setAiInterestArea] = React.useState({});
  const [catURl, setCatURL] = React.useState('');
  const [services, setServices] = React.useState({});
  const firstUpdate = React.useRef(true);
  const inputDomain = React.useRef('');
  const [metadataLayer, setMetadataLayer] = React.useState({
    id: '',
    title: '',
    description: '',
    extent: {
      spatial: {
        crs: '',
        bbox: [0, 0, 0, 0]
      }
    },
    links: [{ href: '' }]
  });
  const classes = useStyles();
  const getCATDirection = atlasObject => {
    if (isNil(atlasObject)) throw new Error('atlas not defined');

    if (!isEmpty(atlasObject.domain)) {
      return atlasObject.domain;
    }
    return `http://${atlasObject.ip}:${atlasObject.port}`;
  };

  const IntervalLoad = async ({ idx, filte, domain, type, loading }) => {
    if (loading) {
      SetLoadingCAT(true);
    }

    const URL = isEmpty(domain) ? catURl : domain;
    const bbox = isEmpty(aiInterestArea) ? false : turf.bbox(aiInterestArea);
    const index = Number.isInteger(idx) ? idx : currentPage;
    const data = await methodPromise('layers.loadCatalogo', {
      index,
      bbox,
      url: URL,
      elementPage: elementePage,
      id: '',
      name_filtered: filte,
      type_service: type
    });
    const ids = [...new Set(map(data.collections, item => item.id))];
    setFilte(ids);
    setServices({ ...data.services });
    SetExist(!data.error_catalog);
    setIndexArray(data.total_matches);
    setIndexJson(data.collections);
    SetLoadingCAT(false);
  };
  const loadIndex = async indexUrlFile => {
    IntervalLoad({ domain: indexUrlFile, loading: true });
    setCatURL(indexUrlFile);
  };

  const redirectToLayerView = () => {
    // Bert.alert(confirmation, 'success');
    window.open('/layers/new', '_self');
  };
  const redirectToLayerViewTab = () => {
    window.open('/layers/new', '_blank');
  };

  const loadDataToSource = data => {
    localStorage.setItem('Metadata', JSON.stringify(data));
    redirectToLayerView(data);
  };
  const loadLocalStorage = (data, isModal) => {
    localStorage.setItem('Metadata', JSON.stringify(data));
    if (!isModal) {
      redirectToLayerViewTab();
    } else {
      setModalShow(true);
    }
  };

  const loadMetadataLayer = async (id, but) => {
    // const data = indexJson.find(x => x.id === id);
    if (fetaureid !== id) {
      SetLoading(true);
      setMetadataLayer({});
      const bbox = isEmpty(aiInterestArea) ? false : turf.bbox(aiInterestArea);
      const data = await methodPromise('layers.loadCatalogo', {
        index: currentPage,
        bbox,
        url: catURl,
        elementPage: elementePage,
        id,
        name_filtered: search
      });
      setMetadataLayer(data.collections);
      SetError(data.error_id);
      setFeatureId(id);
      SetLoading(false);
      const subtype = data.collections.layerTYPE;
      const details = {
        url: data.collections.layerURL,
        subtype,
        isFeature: false
      };
      if (
        isEmpty(data.collections.layerURL) &&
        isEmpty(data.collections.layerTYPE) &&
        !isEmpty(but)
      ) {
        Bert.alert('Service not available', 'danger');
      } else if (but === 'PUSH' && !isEmpty(data.collections.layerURL)) {
        loadDataToSource(details);
      } else if (but === 'TAB' && !isEmpty(data.collections.layerURL)) {
        details.isModal = false;
        loadLocalStorage(details, false);
      } else if (but === 'Modal' && !isEmpty(data.collections.layerURL)) {
        details.isModal = true;
        loadLocalStorage(details, true);
      }
    } else {
      const subtype = metadataLayer.layerTYPE;
      const details = {
        url: metadataLayer.layerURL,
        subtype,
        isFeature: false
      };
      if (isEmpty(metadataLayer.layerURL) && isEmpty(metadataLayer.layerTYPE) && !isEmpty(but)) {
        Bert.alert('Service not available', 'danger');
      } else if (but === 'PUSH' && !isEmpty(metadataLayer.layerURL)) {
        loadDataToSource(details);
      } else if (but === 'TAB' && !isEmpty(metadataLayer.layerURL)) {
        details.isModal = false;
        loadLocalStorage(details, false);
      } else if (but === 'Modal' && !isEmpty(metadataLayer.layerURL)) {
        details.isModal = true;
        loadLocalStorage(details, true);
      }
    }
  };
  const changeElementPerPage = event => {
    const value = Number(event.target.value.trim());
    setElementPage(value);
  };
  const handleOnChangeServerList = evt => {
    const domain = evt.target.value;
    loadIndex(domain);
  };

  const handleSearch = debounce(event => {
    setSearch(event.target.value.trim());
    IntervalLoad({ idx: 1, filte: event.target.value.trim(), loading: false });
    setCurrentPage(1);
  }, 1000);

  const handleSubType = event => {
    event.persist();
    setSubType(event.target.value.trim());
  };
  const updateAIInterestArea = newAIInterestArea => setAiInterestArea(newAIInterestArea);

  React.useEffect(() => {}, [metadataLayer]);
  React.useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return; // Skipping first render
    }

    setFilte([]);
    IntervalLoad({ idx: currentPage, filte: search, type: subType, loading: false });
  }, [elementePage, currentPage, aiInterestArea, subType]);

  const { gmsConnections, deployEnv, isAdmin, isPremium } = props;
  return (
    <>
      <Row>
        <Col xs={6}>
          <div className="row">
            <div className="col-12">
              <h4>Database External</h4>
              <Form.Group>
                <Form.Control
                  as="select"
                  name="gmsConnection"
                  onChange={event => handleOnChangeServerList(event)}
                >
                  <option value="">-</option>
                  {map(gmsConnections, element => {
                    if (element.serverType === 'CAT' || element.serverType === 'CATS')
                      return (
                        <option value={getCATDirection(element)} key={element._id}>
                          {element.name}
                        </option>
                      );
                    return '';
                  })}
                </Form.Control>
              </Form.Group>
            </div>
          </div>
          {(isAdmin || isPremium) && (
            <div className="row">
              <div className="col-10">
                <Form.Control
                  ref={inputDomain}
                  name="DTL-URL"
                  defaultValue="Database Tile Server URL"
                />
              </div>
              <div className="col-2">
                <Button
                  block
                  onClick={() => {
                    loadIndex(inputDomain.current.value);
                  }}
                >
                  Load URL
                </Button>
              </div>
            </div>
          )}

          <br />
          <div className="row">
            <div className="col-12">
              <Row className="m-1" xs={12}>
                <Col
                  xs={12}
                  style={{
                    position: 'relative',
                    textAlign: 'center',
                    overflow: 'hidden',
                    ' height': '100%',
                    maxHeight: '80vh',
                    ' width': '100%',
                    margin: 0,
                    padding: '5px'
                  }}
                >
                  <MapContainerCatalogos
                    aiInterestArea={aiInterestArea}
                    deployEnv={deployEnv}
                    setAIInterestArea={updateAIInterestArea}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Col>
        {loadingCAT && !isEmpty(catURl) && (
          <Col xs={6}>
            <Row>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '50vw',
                  height: '50vh'
                }}
              >
                <Spinner animation="border" />
              </div>
            </Row>
          </Col>
        )}
        {!exist && !loadingCAT && !isEmpty(catURl) && (
          <Col xs={6}>
            <Row>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '50vw',
                  height: '50vh'
                }}
              >
                <h1>This catalog is not available</h1>
              </div>
            </Row>
          </Col>
        )}

        {exist && (
          <Col xs={6}>
            <Row>
              <Col xs={4} className="flex-row align-items-center">
                <Form.Control
                  as="select"
                  defaultValue={elementePage}
                  className="mr-sm-2"
                  id="Elements"
                  onChange={event => changeElementPerPage(event)}
                  custom
                >
                  <option value="10">10 Elements per page</option>
                  <option value="15">15 Elements per page</option>
                  <option value="20">20 Elements per page</option>
                  <option value="30">30 Elements per page</option>
                  <option value="60">60 Elements per page</option>
                </Form.Control>
              </Col>
              <Col xs={4} className="flex-row align-items-center">
                <div className="position-relative">
                  <FontAwesomeIcon
                    className="position-absolute"
                    style={{
                      left: '12px',
                      top: '10px'
                    }}
                    color="var(--gray-light)"
                    icon="search"
                  />
                  <Form.Control
                    type="text"
                    name="search"
                    className="pl-5"
                    placeholder="Search Layer"
                    onKeyUp={e => {
                      e.persist();
                      handleSearch(e);
                    }}
                  />
                </div>
              </Col>
              <Col xs={4} className="flex-row align-items-center">
                <Form.Control
                  as="select"
                  defaultValue={subType}
                  className="mr-sm-2"
                  id="Subtype"
                  onChange={event => handleSubType(event)}
                  custom
                >
                  <option value="">-</option>
                  {map(services, (value, key) => {
                    return (
                      <option value={value} key={value}>
                        {key}
                      </option>
                    );
                  })}
                </Form.Control>
              </Col>
            </Row>
            <PaginationComponent
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setFilte={setFilte}
              elementePage={elementePage}
              globalIndex={indexArray}
              elementPaginttion={11}
            />
            <div className="col-12">
              <Accordion>
                {map(indexJson, ({ title, id }) => {
                  if (filte.includes(id)) {
                    return (
                      <Card padding="0px" key={id}>
                        <Card.Header className="py-0">
                          <Row className="align-items-center justify-content-center" xs={12}>
                            <Col sm={6} md={7} lg={8} xl={9}>
                              <Accordion.Toggle
                                as={Card}
                                className="py-0 border-0"
                                style={{ backgroundColor: 'transparent' }}
                                eventKey={id}
                                onClick={() => loadMetadataLayer(id, '')}
                              >
                                {title}
                              </Accordion.Toggle>
                            </Col>
                            <Col sm={6} md={5} lg={4} xl={3}>
                              <Card
                                className="py-0 border-0"
                                style={{ backgroundColor: 'transparent' }}
                              >
                                <div className="text-left">
                                  <Button
                                    variant="light"
                                    className={classes.azulIpsilum}
                                    title="Open"
                                    onClick={() => loadMetadataLayer(id, 'PUSH')}
                                  >
                                    <FontAwesomeIcon icon="file-alt" size="lg" />
                                  </Button>
                                  <Button
                                    variant="light"
                                    className={classes.azulIpsilum}
                                    title="New Tab"
                                    onClick={() => loadMetadataLayer(id, 'TAB')}
                                  >
                                    <FontAwesomeIcon icon={['fa', 'link']} size="sm" />
                                  </Button>
                                  <Button
                                    variant="light"
                                    className={classes.azulIpsilum}
                                    title="Open Modal"
                                    onClick={() => loadMetadataLayer(id, 'Modal')}
                                  >
                                    <FontAwesomeIcon icon={['fa', 'expand-arrows-alt']} />
                                  </Button>
                                </div>
                              </Card>
                            </Col>
                          </Row>
                        </Card.Header>

                        <Accordion.Collapse eventKey={id}>
                          <Card.Body>
                            {isEmpty(metadataLayer) && <Col xs={12} />}
                            {!isEmpty(metadataLayer) && !error && !loading && (
                              <Col xs={12}>
                                <h4>Tile Metadata</h4>
                                <div className="row">
                                  <div className="col-6">
                                    <Row className="m-1" xs={12}>
                                      <p>ID: {metadataLayer.id}</p>
                                    </Row>
                                    {/* <Row className="m-1" xs={12}>
                                    <p>Schema: {metadataLayer.schema}</p>
                                  </Row> */}
                                    <Row className="m-1" xs={12}>
                                      <p>Name: {metadataLayer.description}</p>
                                    </Row>
                                    {!isEmpty(metadataLayer.layerTYPE) && (
                                      <Row className="m-1" xs={12}>
                                        <p>Service Type: {metadataLayer.layerTYPE}</p>
                                      </Row>
                                    )}

                                    {!isEmpty(metadataLayer.downloadItem) && (
                                      <Row className="m-1" xs={12}>
                                        <p>
                                          Download URL:{' '}
                                          <a
                                            href={metadataLayer.downloadItem}
                                            target="_blank"
                                            rel="noreferrer noopener"
                                          >
                                            <FontAwesomeIcon icon={['fa', 'link']} size="sm" /> Link
                                          </a>
                                        </p>
                                      </Row>
                                    )}
                                  </div>

                                  {!isEmpty(metadataLayer.image) && (
                                    <div className="col-6">
                                      <Row className="m-1" xs={12}>
                                        <img src={metadataLayer.image} alt="" width="100%" />
                                      </Row>
                                    </div>
                                  )}

                                  {!isEmpty(metadataLayer.showURL) && (
                                    <Row className="m-1" xs={12}>
                                      <div className="col-12">
                                        <p>
                                          Tile URL:
                                          <a
                                            href={metadataLayer.showURL}
                                            rel="noreferrer"
                                            target="_blank"
                                          >
                                            {metadataLayer.showURL}
                                          </a>
                                        </p>
                                      </div>
                                    </Row>
                                  )}
                                </div>
                              </Col>
                            )}
                            {loading && (
                              <Col xs={6}>
                                <Row>
                                  <Spinner animation="border" />
                                </Row>
                              </Col>
                            )}
                            {error && !loading && (
                              <Col xs={12}>
                                <p>Service not available</p>
                              </Col>
                            )}
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    );
                  }
                  return false;
                })}
              </Accordion>
            </div>
          </Col>
        )}
      </Row>
      <ModalElement
        modalShow={modalShow}
        onHide={() => setModalShow(false)}
        Componet="New Layer"
        {...props}
      />
    </>
  );
  //  }
};

NewDBExternal.defaultProps = {
  deployEnv: '',
  gmsConnections: [],
  history: {}
};

NewDBExternal.propTypes = {
  deployEnv: PropTypes.string,
  gmsConnections: PropTypes.array,
  history: PropTypes.object,
  isPremium: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired
};
export default withTracker(() => {
  const gmsConnectionsSub = Meteor.isClient && Meteor.subscribe('gmsConnections');
  return {
    loading: !gmsConnectionsSub.ready(),
    gmsConnections: TelemetryConnections.find().fetch()
  };
})(NewDBExternal);
